import React, { FC } from 'react';
import { Tooltip } from '../../common/components/Tooltip';
import { useDataObjectFormLabelTranslation } from '../useDataObjectFormLabelTranslation';
import { DataObjectDescriptionVersionStore } from '../DataObjectDescriptionVersionStore';
import { DataObjectOutputType } from '../types';

export interface AlgorithmSequenceNumberProps {
  sequenceNumber: number;
  execAfterAggregation: boolean | null;
}

export const AlgorithmSequenceNumber: FC<AlgorithmSequenceNumberProps> = (
  props,
) => {
  const { t: tLabel } = useDataObjectFormLabelTranslation();
  const { sequenceNumber, execAfterAggregation } = props;
  const dataObjectDescriptionVersion =
    DataObjectDescriptionVersionStore.useOptionalValue(
      'dataObjectDescriptionVersion',
    );

  if (!sequenceNumber) {
    return;
  }

  if (
    !dataObjectDescriptionVersion ||
    dataObjectDescriptionVersion.outputTypeCode ===
      DataObjectOutputType.REPORT ||
    dataObjectDescriptionVersion.dimensions?.every(
      (dimension) => !dimension.aggregateHierarchy,
    )
  ) {
    return sequenceNumber;
  }

  return (
    <Tooltip
      title={`${sequenceNumber} (${
        execAfterAggregation
          ? tLabel('algorithms.sequenceNumber.execAfterAggregation.tooltip')
          : tLabel('algorithms.sequenceNumber.execBeforeAggregation.tooltip')
      })`}
      placement="left"
    >
      {`${sequenceNumber} (${
        execAfterAggregation
          ? tLabel('algorithms.sequenceNumber.execAfterAggregation.label')
          : tLabel('algorithms.sequenceNumber.execBeforeAggregation.label')
      })`}
    </Tooltip>
  );
};
